<template>
  <b-modal ref="modal" :title="title" @ok="okClicked">
    <b-form-group
      id="scene-input-group-1"
      :label="$t('scene-name')"
      label-for="scene-name"
    >
      <b-form-input
        id="scene-name"
        v-model="sceneForm.name"
        type="text"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group
      id="scene-input-group-2"
      :label="$t('scene-icon')"
      label-for="scene-icon"
    >
      <icon-picker v-model="sceneForm.icon" />
    </b-form-group>
  </b-modal>
</template>

<script>
import IconPicker from '@/components/controls/IconPicker.vue';

export default {
  name: 'SceneModalForm',
  data() {
    return {
      sceneForm: {
        name: '',
        icon: '',
      },
    };
  },
  props: {
    title: {
      type: String,
    },
  },
  methods: {
    okClicked() {
      this.$emit('ok', { name: this.sceneForm.name, icon: this.sceneForm.icon });
      this.sceneForm.name = '';
      this.sceneForm.icon = '';
    },
    initData({ name, icon }) {
      this.sceneForm.name = name;
      this.sceneForm.icon = icon;
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  components: {
    IconPicker,
  },
};
</script>

<style scoped>

</style>
